import React, { useState, useEffect } from 'react';

export default function Loader({isOpen}) {
  const [isVisible, setIsVisible] = useState();
  const [transition, setTransition] = useState({ opacity: '0'});

  useEffect(() => {
    let timeoutId;

    if (isOpen) {
      setIsVisible(true);
      timeoutId = setTimeout(() => {
        setTransition({ opacity: '1' });
      }, 10);
    } else {
      setTransition({ opacity: '0' });
      timeoutId = setTimeout(() => {
        setIsVisible(false);
      }, 800);
    }
    return () => clearTimeout(timeoutId);
  }, [isOpen]);

  if(isVisible){
    return (
      <div data-testid="loader" className='transition loader-container' style={transition}>
        {/* <img src='/loader.gif' style={{width:'5rem'}}/> */}
      </div>
    );
  }
  else{
    return null
  }
}
